import { Backend } from '@/_axios';

export default {
  categoriesSearchProducts(name = '') {
    return Backend.get('/categories/search-products', { params: { name: name } });
  },
  categoriesList() {
    return Backend.get('/categories');
  },
  category(id) {
    return Backend.get(`/categories/${id}`);
  },
  categoryCreateData() {
    return Backend.get('/categories/create');
  },
  categoryUpdateData(id) {
    return Backend.get(`/categories/${id}/edit`);
  },
  categoryCreate(createData) {
    return Backend.post('/categories/', createData);
  },
  categoryUpdate(id, updateData) {
    return Backend.put(`/categories/${id}`, updateData);
  },

  productsAXSearch(name = '') {
    return Backend.get('/products/search-ax-products', { params: { name: name } });
  },
  productsList(params) {
    return Backend.get('/products', { params });
  },
  product(id) {
    return Backend.get(`/products/${id}`);
  },
  productCreateData() {
    return Backend.get('/products/create');
  },
  productUpdateData(id) {
    return Backend.get(`/products/${id}/edit`);
  },
  productClassifiers() {
    return Backend.get('/products/classifiers');
  },
  productCreate(createData) {
    return Backend.post('/products/', createData);
  },
  productUpdate(id, updateData) {
    return Backend.put(`/products/${id}`, updateData);
  },
  productUpdateActive(id, isActive) { // isActive 0/1
    return Backend.put(`/products/${id}/change-active/${isActive}`);
  },
};
